export function getDeviceImageUrl(
  deviceHandle: string,
  productLine: string,
  colorHandle: string,
): string {
  return `https://image.rhinoshield.app/materials/device/${deviceHandle}?product-line=${productLine}&color=${colorHandle}&size=1080`
}
